import React, { useState } from 'react';
import HomePage from './components/HomePage';
import './App.css';
import './Login.css';

const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  // **📨 Send OTP API Call**
  const sendOtp = async () => {
    if (!email) return alert("Please enter your email!");
    setLoading(true);
    try {
      const response = await fetch('http://localhost:5002/api/otp/send-otp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      alert(data.message || data.error);
      if (response.ok) setStep(2);
    } catch (error) {
      alert("Something went wrong! Try again.");
    }
    setLoading(false);
  };

  // **✅ Verify OTP**
  const verifyOtp = async () => {
    if (!otp) return alert("Please enter the OTP!");
    setLoading(true);
    try {
      const response = await fetch('http://localhost:5002/api/otp/verify-otp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp }),
      });
      const data = await response.json();
      if (!response.ok) return alert(data.error);
      alert("OTP Verified! Now reset your password.");
      setStep(3);
    } catch (error) {
      alert("Something went wrong!");
    }
    setLoading(false);
  };

  // **🔑 Reset Password**
  const resetPassword = async () => {
    if (!newPassword) return alert("Please enter a new password!");
    setLoading(true);
    try {
      const response = await fetch('http://localhost:5002/api/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, newPassword }),
      });
      const data = await response.json();
      if (!response.ok) return alert(data.error);
      alert("Password reset successful! Now login.");
      setStep(1);
      setEmail('');
      setOtp('');
      setNewPassword('');
    } catch (error) {
      alert("Something went wrong!");
    }
    setLoading(false);
  };

  return (
    <>
      <HomePage />
      <div className="form-container">
        <h2>Forget Password</h2>
        {step === 1 && (
          <div className="form-group">
            <label>Email:</label>
            <input type="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <button className="submit-btn" onClick={sendOtp} disabled={!email || loading}>{loading ? "Sending..." : "Send OTP"}</button>
          </div>
        )}
        {step === 2 && (
          <div className="form-group">
            <label>OTP:</label>
            <input type="text" placeholder="Enter OTP" value={otp} onChange={(e) => setOtp(e.target.value)} required />
            <button className="submit-btn" onClick={verifyOtp} disabled={!otp || loading}>{loading ? "Verifying..." : "Verify OTP"}</button>
          </div>
        )}
        {step === 3 && (
          <div className="form-group">
            <label>New Password:</label>
            <input type="password" placeholder="Enter new password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
            <button className="submit-btn" onClick={resetPassword} disabled={!newPassword || loading}>{loading ? "Resetting..." : "Reset Password"}</button>
          </div>
        )}
      </div>
    </>
  );
};

export default ForgetPassword;
